module.exports = __webpack_public_path__ + "static/img/govIcon.37c9b3a2.gif";